import {
  PokemonType,
  SkillData,
  SkillType,
  SkillRangeType,
  SkillEvent_Vfx,
  SkillEvent_Heal,
} from "types/battle-engine/battle";
import { parseSkillIdToName } from "../utils/parse-id-to-name";
import { msToTicks } from "../utils/ms-to-ticks";

// 1-ally Healing Skills
export const [REFRESH, LIFE_DEW, COACHING, PURIFY, ROOST]: SkillData[] = [
  {
    id: "refresh",
    description: "Heals an ally.",
    pokemon_type: PokemonType.NORMAL,
    healing: 30,
  },
  {
    id: "life-dew",
    description: "Heals an ally.",
    pokemon_type: PokemonType.WATER,
    healing: 30,
  },
  {
    id: "coaching",
    description: "Heals an ally.",
    pokemon_type: PokemonType.FIGHTING,
    healing: 30,
  },
  {
    id: "purify",
    description: "Heals an ally.",
    pokemon_type: PokemonType.POISON,
    healing: 30,
  },
  {
    id: "roost",
    description: "Heals an ally.",
    healing: 30,
    pokemon_type: PokemonType.FLYING,

  },
].map((skill: any) => ({
  id: skill.id,
  event_checks:
    "event_checks" in skill
      ? (skill.event_checks as SkillData["event_checks"])
      : undefined,
  momentum:
    "momentum" in skill ? (skill.momentum as SkillData["momentum"]) : undefined,
  team_conditions:
    "team_conditions" in skill
      ? (skill.team_conditions as SkillData["team_conditions"])
      : undefined,
  starts_active:
    "starts_active" in skill ? (skill.starts_active as boolean) : undefined,
  name: parseSkillIdToName(skill.id),
  description: skill.description || "",
  power: 10,
  pokemon_type: skill.pokemon_type,
  types: [SkillType.HEAL],
  cooldown_ticks: 100,
  mana_cost: 10,
  range: {
    type: SkillRangeType.POINT_TARGET,
    value: 5,
  },
  on_hit: [],
  on_cast: [
    {
      __typename: "Vfx",
      duration_ticks: 15,
      target: {
        type: "self",
        id: 0,
      },
      status_effects: [],
      starting_tick: 0,
      sprite_path: "/assets/spells/vfx/self_sparkles_006__50.png",
      sprite_scale: 2,
      speed: 1.25,
      blocks_event_pipeline: false,
    } as SkillEvent_Vfx,
    {
      __typename: "Vfx",
      duration_ticks: 25,
      target: {
        type: "ally",
        id: 0,
      },
      status_effects: [],
      starting_tick: 0,
      sprite_path: "/assets/spells/self/healing-2-green.png",
      sprite_scale: 1.5,
      sprite_alpha: 1,
      speed: 0.2,
      blocks_event_pipeline: true,
    } as SkillEvent_Vfx,
    {
      __typename: "Heal",
      duration_ticks: 20,
      target: {
        type: "ally",
        id: 0,
      },
      status_effects: [],
      starting_tick: 0,
      heal_amount: skill.healing ?? 25,
      blocks_event_pipeline: true,
    } as SkillEvent_Heal,
  ],
}));